import * as React from 'react';
import { generatePath } from 'react-router-dom';
import { SRP_BASE } from '../../urls';
import Helmet from 'react-helmet';

const styles = require('./Error500.scss');
const backgroundImg = require('../../assets/images/ballroom.jpg');

export class Error500 extends React.Component {
    render() {
        return (
            <div className={styles.className}>
                <Helmet>
                    <title>Oops - Wedding Spot</title>
                </Helmet>
                <div className={styles.background}>
                    <img alt='Ballroom background' src={backgroundImg} />
                </div>
                <div className={styles.messageWrapper}>
                    <div className={styles.messageContainer}>
                        <h3 className={styles.headline}>Oops!</h3>
                        <p>
                            We're down for a bit but the team is working hard to fix this! Please check back in a few minutes. If this
                            continues to be an issue, please <a href='mailto:support@wedding-spot.com'>let us know </a>
                            how you landed on this page and we will look into it.
                        </p>
                        <p>
                            <a href={generatePath(SRP_BASE)} className={styles.button}>
                                Find a venue
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Error500;
